import * as types from "../ActionType";
import axios from "axios";
import { notifyError, notifysuccess } from "../../components/general/Notification";
import { hasExpirition } from "../../components/general/general-component/abstruct-component/useExpirition";
const END_POINT = process.env.REACT_APP_BASE_URL_WAREHOUSE;

const get = (arr, type) => {
    return ({
        type: type,
        payload: arr
    })
}
const add = (type) => {
    return ({
        type: type
    })
}
const delelte = (type) => {
    return ({
        type: type
    })
}
const edit = (type) => {
    return ({
        type: type
    })
}

export const postZoneType = (name, symbol, warehouse_id,description, setLoad) => {
    return function (dispatch) {
        setLoad(true)
        let token = localStorage.getItem("tokenA");
        axios.post(`${END_POINT}/api/warehouses/zone-types`,
            { name, symbol, warehouse_id ,description}
            , {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }).then((res) => {
                if (res.data.status === "Success") {
                    dispatch(add(types.ADD_ZONE_TYPE));
                    dispatch(loadZonesType());
                    notifysuccess(res.data.message)
                    setLoad(false)
                }
            }).catch((err) => {
                setLoad(false)
                notifyError(err.response.data.message)
            })
    }
}
export const loadZonesType = () => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        axios.get(`${END_POINT}/api/warehouses/zone-types`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status == "Success") {
                dispatch(get(res.data.data, types.GET_ZONES_TYPE));
            }
        }).catch((err) => {
            notifyError(err.response.data.message)
        })
    }
}

export const deleteZoneType = (id, setloadDel, setIsDeleted, setIdDeleted) => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        setloadDel(true)
        axios.delete(`${END_POINT}/api/warehouses/zone-types/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status == "Success") {
                dispatch(delelte(types.DELETE_ZONE_TYPE));
                notifysuccess(res.data.message)
                setIsDeleted('deleted')
                setIdDeleted(id)
                setloadDel(false)
            }
        }).catch((err) => {
            setloadDel(false)
            notifyError(err.response.data.message)
        })
    }
}




